import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMenuAccessApi, postMasterApi, getMasterApi, getMasterById,marketplaces, updateMasterApi, getAllCountriesApi, getNotificationApi, markAsReadNotficationsApi } from '../services/Apis';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchMasterData } from '../slices/globalslice';
import { toast } from 'react-toastify';
export default function useMaster() {
  const auth_status = useSelector(state => state.globalslice.auth_status);
  const initial_page = useSelector(state => state.globalslice.initial_page);
  const sorting_data = useSelector(state => state.globalslice.sorting_data);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const queryClient = useQueryClient();

  // Menu access query
  const getMenuAccess = () => {
    return useQuery({
      queryKey: ['menu-access'],
      queryFn: () => getMenuAccessApi(),
      enabled: auth_status,
      cacheTime: Infinity,
      staleTime: Infinity,
    });
  };

  const getAllCountries = () => {
    return useQuery({
      queryKey: ["countries_list"],
      queryFn: () => getAllCountriesApi(),
      enabled: auth_status,
      cacheTime: Infinity,
      staleTime: Infinity,
    });
  };
      const getmarketplaces = () => {
    return useQuery({
      queryKey: ["marketplace_list"],
      queryFn: () => marketplaces(),
      enabled: auth_status,
      cacheTime: Infinity,
      staleTime: Infinity,
    });
  };

  const postMaster = useMutation({
    mutationFn: (formData) => {
      if (formData.id) {
        return updateMasterApi(formData);  // if id exists — update
      } else {
        return postMasterApi(formData);    // else — create
      }
    },
    onSuccess: (data) => {
      toast.success('Master data updated successfully',100)
      queryClient.getQueryCache().findAll().forEach((query) => {
        if (query.queryKey[0] === 'master') {
          queryClient.removeQueries({ queryKey: query.queryKey });
        }
      });
      queryClient.invalidateQueries({ queryKey: ['masterById', { id: data.data.toString() }] });
      dispatch(fetchMasterData())
      navigate('/admin/masterlist')
    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });

  //Master List
  const getMaster = (perPage) => {
    return useQuery({
      queryKey: ['master', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
      queryFn: () => getMasterApi({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updated_date', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }

  const getMasterDataById = (id) => {
    return useQuery({
      queryKey: ['masterById', { 'id': id }],
      queryFn: () => getMasterById(id),
      enabled: !!id,   // <--- only run if id (slug) exists
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }

  const getNotifications = () => {
    return useQuery({
      queryKey: ['notifications'],
      queryFn: () => getNotificationApi(),
      enabled: auth_status,
      cacheTime: Infinity,
      staleTime: Infinity,
    });
  };


  const markAsReadNotfications = useMutation({
    mutationFn: (formData) => {
      return markAsReadNotficationsApi(formData);  // if id exists — update
    },
    onSuccess: (data) => {
      // queryClient.getQueryCache().findAll().forEach((query) => {
      //   if (query.queryKey[0] === 'notifications') {
      //     queryClient.removeQueries({ queryKey: query.queryKey });
      //   }
      // });
    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });


  return {
    getMenuAccess,
    getNotifications,
    postMaster,
    getMaster,
    getMasterDataById,
    getAllCountries,
    markAsReadNotfications,
    getmarketplaces
    
  };
}
